export class Config {

    public zoneList:any = [

        { CODE:'C', DESC:'Central' },
        { CODE:'E', DESC:'East' },
        { CODE:'W', DESC:'West' },
        { CODE:'N', DESC:'North' },
        { CODE:'S', DESC:'South' },
    ]

    public regionList:any = [
        { ZONE:'C', CODE:'C1', DESC:'C1' },
        { ZONE:'C', CODE:'C2', DESC:'C2' },
        { ZONE:'C', CODE:'C3', DESC:'C3' },
        { ZONE:'C', CODE:'C4', DESC:'C4' },

        { ZONE:'E', CODE:'E1', DESC:'E1' },
        { ZONE:'E', CODE:'E2', DESC:'E2' },
        { ZONE:'E', CODE:'E3', DESC:'E3' },
        { ZONE:'E', CODE:'E4', DESC:'E4' },

        { ZONE:'N', CODE:'N1', DESC:'N1' },
        { ZONE:'N', CODE:'N2', DESC:'N2' },
        { ZONE:'N', CODE:'N3', DESC:'N3' },
        { ZONE:'N', CODE:'N4', DESC:'N4' },

        { ZONE:'S', CODE:'S1', DESC:'S1' },
        { ZONE:'S', CODE:'S2', DESC:'S2' },
        { ZONE:'S', CODE:'S3', DESC:'S3' },
        { ZONE:'S', CODE:'S4', DESC:'S4' },

        { ZONE:'W', CODE:'W1', DESC:'W1' },
        { ZONE:'W', CODE:'W2', DESC:'W2' },
        { ZONE:'W', CODE:'W3', DESC:'W3' },
        { ZONE:'W', CODE:'W4', DESC:'W4' }
    ]

    public cityList:any = [

    ]

    public outletList:any = [

    ]
}